export enum FormState {
    Create = 0,
    Read = 1,
    Update = 2,
    Delete = 3
}

export enum FormFieldTypes {
    Text = 'text',
    Email = 'email',
    Password = 'password',
    Number = 'number',
    Tel = 'tel',
    Url = 'url',
    Select = 'select',
    Textarea = 'textarea'
}

export enum FormMask {
    TelPattern = "(000) 000-0000",    
    TelExtPattern = "0000000000",
    ZipPostal_US_Pattern = "00000||00000-0000",
    ZipPostal_CA_Pattern = "S0S 0S0",
    // An empty mask is a pass-through in ngx-mask. The seven international countries have seven
    // different postal formats, so the field is left unmasked and the provider is the authority.
    ZipPostal_International_Pattern = ""
}

export enum FormValidatorMessages {
    FirstNameRequired = 'First name is required',
    LastNameRequired = 'Last name is required',
    EmailRequired = 'Email is required',
    EmailInvalid = 'Please enter a valid email address',
    PhoneRequired = 'Telephone number is required',
    PhoneInvalid = 'Please enter a valid 10-digit phone number',
    PhoneExtensionWithoutNumber = 'Please enter a telephone number if you are providing an extension',
    SlugInvalidCharacters = 'Only lowercase letters, numbers, and hyphens',
    SlugInvalidHyphens = 'No leading, trailing, or consecutive hyphens',
    SlugRequired = 'Domain Path is required',
    OrganizationRequired = 'Organization name is required',
    OrganizationReplyToEmailAddressRequired = 'Reply-To Email Address is required',
    TitleRequired = 'Title is required',
    LotNumberRequired = 'Lot Number is required',
    CountryRequired = 'Country is required',
    PrimaryAddressRequired = 'Address Line 1 is required',
    SecondaryAddressRequired = 'Address Line 2 is required',
    CityRequired = 'City is required',
    StateProvinceRequired = 'State/Province is required',
    ZipPostalRequired = 'ZIP/Postal Code is required',
    ZipPostal_US_Pattern = 'ZIP Codes must contain either 5 or 9 digits.',
    ZipPostal_CA_Pattern = 'Postcodes must follow this format: <br/>[letter][number][letter] [number][letter][number]',
    ZipPostal_International_Pattern = 'Postal codes may contain letters, numbers, spaces and hyphens only.',
    NoteRequired = 'Note is required',
    TypeToConfirmRequired = 'Confirmation text is required',
    TypeToConfirmMismatch = 'Confirmation text does not match',
    AmountRequired = 'Amount is required',
    ExpenseAmountMin = 'Amount must be at least $0.01',
    ExpenseReferenceNumberMaxLength = 'Reference number cannot exceed 30 characters',
    ExpenseReferenceNumberPattern = 'Only letters, numbers, hyphens, and slashes are allowed',
    ExpenseDescriptionMaxLength = 'Description cannot exceed 500 characters',
    ExpensePayeeNameRequired = 'Payee name is required',
    ExpensePayeeNameMinLength = 'Payee name must be at least 2 characters',
    ExpensePayeeNameMaxLength = 'Payee name cannot exceed 250 characters',
    ExpensePaidDateRequired = 'Date paid is required',
    ExpenseTypeRequired = 'Expense type is required',
    ExpenseLiabilityAccountRequired = 'Liability account is required',
    ExpenseTypeNoAccountsAvailable = 'An expense chart of account must be configured for this organization before an expense can be saved.',
    ExpenseLiabilityAccountNoAccountsAvailable = 'A liability chart of account must be configured for this organization before an expense can be saved.',
    InvoiceScheduleRevenueTypeNoAccountsAvailable = 'A revenue chart of account must be configured for this organization before an invoice schedule can be saved.',
    InvoiceScheduleAssetTypeNoAccountsAvailable = 'An asset chart of account must be configured for this organization before an invoice schedule can be saved.',
    ChargeScheduleAmountInvalid = 'Please enter a valid dollar amount',
    ChargeScheduleEndDateBeforeMonthEnd = 'End Date must be on or after {date} because this schedule issues at the end of the month',
    LateFeesRevenueAccountRequired = 'Select a late fee revenue account.',
    LateFeesAtLeastOneTier = 'Add at least one fee configuration when late fees are enabled.',
    LateFeeTierAmountRequired = 'Fees amount is required.',
    LateFeeTierAmountMin = 'Fees amount must be greater than $0.00.',
    LateFeeTierGracePeriodRequired = 'Grace period is required.',
    LateFeeTierOccurrencesRequired = 'Occurrences is required.',
    LateFeeTierFrequencyRequired = 'Frequency is required.',
    LateFeeTierMultipleCountRequired = 'Number of times is required.',
    LateFeeTierMultipleCountMin = 'Number of times must be 2 or more.',
    AccountHolderNameRequired = 'Account holder name is required',
    AccountHolderNameMinLength = 'Account holder name must be at least 2 characters',
    RoutingNumberRequired = 'Routing number is required',
    RoutingNumberPattern = 'Routing number must be exactly 9 digits',
    AccountNumberRequired = 'Account number is required',
    AccountNumberMinLength = 'Account number must be between 4 and 17 digits',
    AccountNumberPattern = 'Account number must contain only digits',
    MarkInvoicePaymentTypeRequired = 'Payment type is required',
    MarkInvoiceCheckNumberMaxLength = 'Check number cannot exceed 30 characters',
    MarkInvoiceCheckNumberPattern = 'Only letters, numbers, hyphens, and slashes are allowed',
    MarkInvoiceNoteMaxLength = 'Note cannot exceed 500 characters',
    NoteMaxLength = 'Note cannot exceed 255 characters',
    RefundPaymentPayableAccountRequired = 'Payable account is required',
    ManualGLEntryEffectiveDateRequired = 'Effective date is required',
    ManualGLEntryAccountRequired = 'Chart of account is required',
    ManualGLEntryAmountMin = 'Amount must be greater than $0.00',
    ManualGLEntryUnbalanced = 'Total debits must equal total credits',
    BudgetYearRequired = 'A year is required',
    BudgetYearRange = 'Year must be between 2000 and 2100',
    BudgetYearTaken = 'A budget already exists for this year',
    BudgetAccountRequired = 'Please select an account',
    BudgetAccountDuplicate = 'This account is already in the budget',
    BudgetAmountRequired = 'An amount is required',
    BudgetAmountMin = 'Amount cannot be negative',
    BudgetAtLeastOneLine = 'Add at least one account before saving',
    OrganizationContactNameRequired = 'Contact name is required',
    OrganizationContactTypeRequired = 'Contact type is required',
    MessageSuppressionOverrideEmailRequired = 'Override email address is required when email recipient override is enabled',
    CommunicationsSubjectRequired = 'Subject is required',
    CommunicationsSubjectMaxLength = 'Subject cannot exceed 150 characters',
    CommunicationsBodyRequired = 'Message body is required',
    CommunicationsFooterRequired = 'Footer is required',
    SupportTicketTitleRequired = 'Title is required',
    SupportTicketTitleMaxLength = 'Title cannot exceed 150 characters',
    SupportTicketBodyRequired = 'Message body is required',
    BankStatementBalanceRequired = 'Your statement balance is required',
    BankStatementDateRequired = 'The date this balance was taken is required',
    BankStatementDateFuture = 'The statement date cannot be in the future',
    DigitsOnly = 'Enter digits only',
    ImportRowPhoneCountryCodeRequired = 'Country code is required when a phone number is entered',
    ImportRowPhoneCountryCodeInvalid = 'Enter up to 3 digits, with or without a leading +',
    ImportRowPhoneNumberInvalid = 'Enter up to 10 digits; spaces, brackets, dots and dashes are ignored',
    ImportRowValueTooLong = 'Use {maxLength} characters or fewer',
    ImportRowOwnerOrTenantInvalid = 'Choose Owner or Tenant'
}

export enum InvoiceScheduleHelpText {
    Description = 'A description for the Invoice Schedule. Only Admins and the Owner can view it.',
    ActivateCharge = 'Activates this Invoice Schedule to enable invoice creation.',
    IncomeType = 'The income category these invoices are recorded under.',
    AssetType = 'The asset account where payments for these invoices are recorded.',
    Frequency = 'Sets how often invoices are sent.',
    IssuanceDate = 'Sets when invoices are sent.',
    InvoiceInstructions = 'Instructions that show on the invoice.',
    LateFeeRevenueAccount = 'The income category late fees are recorded under.'
}

export enum MultiSelectLabelText {
    Role = 'Role:',
    Status = 'Status:',
    BillingStatus = 'Billing Status:',
    PricingTier = 'Pricing Tier:'
}


